import ReactDatePicker from "react-datepicker";
import 'react-datepicker/dist/react-datepicker.css';
import MaskedInput from 'react-text-mask';
import { useServerDate } from "services/ServerDateContext";
import createAutoCorrectedDatePipe from 'text-mask-addons/dist/createAutoCorrectedDatePipe';

const DatePick_MI = (props) => {
    const serverDate = new Date(useServerDate());
    var setMinMax = (props?.noMinMax) ? false : true
    var minDate = props?.setToday ? serverDate.setDate(serverDate.getDate()) : serverDate.setDate(serverDate.getDate() + 1);
    var maxDate = serverDate.setDate(serverDate.getDate() + 30);
    var displayCalendar = props?.displayCalendar ? props?.displayCalendar : "top-start"
    const autoCorrectedDatePipe = createAutoCorrectedDatePipe('mm/dd/yyyy HH:MM');

    // Sets min and max dates for 30 days before and after the current date
    if (props?.set30Days) {
        minDate = (props?.set30Days ? new Date().setDate(new Date().getDate() - 30) : minDate);
        maxDate = (props?.set30Days ? new Date().setDate(new Date().getDate() + 30) : maxDate);
    }

    // Formats date
    const dateFormat = (date) => {
        var saveFormattedDate
        if (date != "" && date !== null) {
            var month = date.getMonth() + 1;
            var day = date.getDate();
            var year = date.getFullYear();

            // Appends 0 to the front of a single digit
            if (month > 0 && month < 10) {
                month = "0" + month.toString();
            }
            if (day < 10) {
                day = "0" + day.toString();
            }

            // Sets year to current year if input exceeds range
            if (year > new Date(serverDate).getFullYear()) {
                year = new Date(serverDate).getFullYear();
            }

            saveFormattedDate = month + '/' + day + '/' + year
            props.setDateSubmit(new Date(saveFormattedDate));
        }
        else {
            saveFormattedDate = "";
            props.setDateSubmit("")
        }

        if (props?.infoKey) {
            if(props?.infoKey == "requestedEffDate"){
                props.storeValue(props.nameValue, saveFormattedDate);
            }
            else{
                props.storeValue(props.nameValue, saveFormattedDate, props.infoKey)
            }
        }
        else {
            props.storeValue(props.nameValue, saveFormattedDate);
        }
        
    }
    const { dateSubmit = "" } = props
    return (
        <>
            <ReactDatePicker
                minDate={setMinMax ? minDate : false}
                maxDate={setMinMax ? maxDate : false}
                popperPlacement={displayCalendar}
                popperModifiers={[
                    {
                        name: "offset"
                    },
                    {
                        name: "preventOverflow",
                        options: {
                            rootBoundary: "viewport",
                            tether: false,
                            altAxis: true,
                        },
                    },
                ]}
                value={dateSubmit || ""}
                type={"text"}
                autoComplete="off"
                name={props?.infoKey =="requestedEffDate"?"requestedEffDate":props?.infoKey? props?.infoKey + "_" + props?.nameValue : "DateChanged"}
                placeholderText="MM/DD/YYYY"
                className="fw-light col-sm-12 btn btn-default btn-group"
                isClearable
                selected={dateSubmit !== "" ? new Date(dateSubmit) : new Date(serverDate)}
                customInput={
                    <MaskedInput
                        pipe={autoCorrectedDatePipe}
                        mask={[/\d/, /\d/, '/', /\d/, /\d/, '/', /\d/, /\d/, /\d/, /\d/]}
                        keepCharPositions={true}
                        guide={true}
                        inputMode='numeric'
                    />
                }
                onChange={(text) => {
                    dateFormat(text);
                }}
            />
        </>
    )
}

export default DatePick_MI